var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChartSafeMoneyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "safe-money-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.768,
    height: 12.767,
    viewBox: "0 0 16.768 12.767",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3041",
    "data-name": "Group 3041",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M9.331,121.535a12.431,12.431,0,0,0,3.1-1.639.925.925,0,0,1,1.134,0,9.3,9.3,0,0,0,1.261.8v-4.776a.608.608,0,0,0-.607-.607H.607a.608.608,0,0,0-.607.607v6.035a.608.608,0,0,0,.607.607H8.743c0-.042-.005-.082-.007-.118A.93.93,0,0,1,9.331,121.535Zm-.819-.7a1.394,1.394,0,0,1-.729.394v.1a.313.313,0,0,1-.312.312H7.336a.313.313,0,0,1-.312-.312v-.106a1.744,1.744,0,0,1-.428-.153,1.2,1.2,0,0,1-.456-.435,1.428,1.428,0,0,1-.182-.456A.3.3,0,0,1,6,119.942a.31.31,0,0,1,.206-.134l.135-.024a.284.284,0,0,1,.054-.005.315.315,0,0,1,.3.236.886.886,0,0,0,.142.324.741.741,0,0,0,.583.269.876.876,0,0,0,.118-.009.69.69,0,0,0,.418-.22.682.682,0,0,0,.165-.467.562.562,0,0,0-.111-.369,1.1,1.1,0,0,0-.614-.3,2.991,2.991,0,0,1-.834-.286,1.047,1.047,0,0,1-.418-.42,1.237,1.237,0,0,1-.146-.6,1.222,1.222,0,0,1,.422-.961,1.3,1.3,0,0,1,.593-.281v-.153a.313.313,0,0,1,.312-.312h.135a.313.313,0,0,1,.312.312v.156a1.331,1.331,0,0,1,.553.258,1.191,1.191,0,0,1,.366.527.307.307,0,0,1-.026.264.312.312,0,0,1-.224.149l-.132.019a.424.424,0,0,1-.047,0,.314.314,0,0,1-.3-.212.558.558,0,0,0-.583-.4.69.69,0,0,0-.513.21.537.537,0,0,0-.141.376.546.546,0,0,0,.118.359,1.231,1.231,0,0,0,.741.319,2.5,2.5,0,0,1,.512.141,1.361,1.361,0,0,1,.42.278,1.134,1.134,0,0,1,.255.394,1.437,1.437,0,0,1-.271,1.447Z",
    transform: "translate(0 -115.314)",
    fill: "#29235c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M539.53,398.712c-.413-.16-.786-.319-1.119-.475-.182-.085-.364-.173-.543-.265A10.238,10.238,0,0,1,536.3,397a.43.43,0,0,0-.527,0,12.9,12.9,0,0,1-3.227,1.709.435.435,0,0,0-.278.425,6.1,6.1,0,0,0,.071.685,6.64,6.64,0,0,0,3.49,4.921.435.435,0,0,0,.413,0,6.7,6.7,0,0,0,3.56-5.608A.434.434,0,0,0,539.53,398.712Z",
    transform: "translate(-523.04 -392.028)",
    fill: "#29235c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartSafeMoneyIcon);
export default __webpack_public_path__ + "static/media/chart-safe-money-icon.dba46f13.svg";
export { ForwardRef as ReactComponent };